import React, { useState, useRef } from 'react';
import { createWheel, uploadWheelImages } from '../api';
import './newwheelmodal.css';

const NewWheelModal = ({ showModal, toggleModal, onWheelCreated }) => {
  const [form, setForm] = useState({
    name: '',
    paint_color: '',
    paint_code: '',
    part_number: '',
    notes: '',
  });
  const [pendingFile, setPendingFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const fileInputRef = useRef(null);

  if (!showModal) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setPendingFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleRemovePhoto = () => {
    setPendingFile(null);
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    setPreviewUrl(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const wheel = await createWheel(form);
      let finalWheel = { ...wheel, images: [] };

      if (pendingFile) {
        try {
          const uploaded = await uploadWheelImages(wheel.id, [pendingFile]);
          finalWheel = { ...wheel, images: uploaded };
        } catch (imgErr) {
          console.error('Image upload failed:', imgErr);
          // wheel was created; proceed without photo
        }
      }

      if (onWheelCreated) onWheelCreated(finalWheel);
      setForm({ name: '', paint_color: '', paint_code: '', part_number: '', notes: '' });
      handleRemovePhoto();
      toggleModal();
    } catch (error) {
      console.error('Error creating wheel:', error);
      alert('Failed to create wheel.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) toggleModal();
  };

  return (
    <div className="newwheel-overlay" onClick={handleOverlayClick}>
      <div className="newwheel-modal">
        <div className="newwheel-header">
          <span className="newwheel-title">New Wheel Record</span>
          <div className="newwheel-header-actions">
            <button type="submit" form="newwheel-form" className="newwheel-submit-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Creating...' : 'Create'}
            </button>
            <button type="button" className="newwheel-close-btn" onClick={toggleModal}>✕</button>
          </div>
        </div>

        <form id="newwheel-form" className="newwheel-form" onSubmit={handleSubmit}>

          {/* Photo picker */}
          <div className="newwheel-photo-row">
            {previewUrl ? (
              <div className="newwheel-preview-wrap">
                <img src={previewUrl} alt="Preview" className="newwheel-preview-img" />
                <button
                  type="button"
                  className="newwheel-remove-photo"
                  onClick={handleRemovePhoto}
                  title="Remove photo"
                >✕</button>
              </div>
            ) : (
              <button
                type="button"
                className="newwheel-photo-btn"
                onClick={() => fileInputRef.current?.click()}
              >
               Add Photo
              </button>
            )}
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              capture="environment"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </div>

          <div className="newwheel-field">
            <label className="newwheel-label">Wheel Name</label>
            <input
              className="newwheel-input"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder=""
            />
          </div>

          <div className="newwheel-field">
            <label className="newwheel-label">Paint Color</label>
            <input
              className="newwheel-input"
              name="paint_color"
              value={form.paint_color}
              onChange={handleChange}
              placeholder=""
            />
          </div>

          <div className="newwheel-field">
            <label className="newwheel-label">Paint Code</label>
            <input
              className="newwheel-input"
              name="paint_code"
              value={form.paint_code}
              onChange={handleChange}
              placeholder=""
            />
          </div>

          <div className="newwheel-field">
            <label className="newwheel-label">Part #</label>
            <input
              className="newwheel-input"
              name="part_number"
              value={form.part_number}
              onChange={handleChange}
              placeholder=""
            />
          </div>

          <div className="newwheel-field">
            <label className="newwheel-label">Notes</label>
            <textarea
              className="newwheel-textarea"
              name="notes"
              value={form.notes}
              onChange={handleChange}
              placeholder=""
              rows={3}
            />
          </div>

        </form>
      </div>
    </div>
  );
};

export default NewWheelModal;
